export const ROUTE_SETTINGS = 'SETTINGS';
